<template>
    <div  class="offcanvas offcanvas-start overflow-auto shadow my" role="button" tabindex="-1" data-bs-scroll="true" data-bs-backdrop="false" id="offcanvasExample" aria-labelledby="offcanvasExampleLabel">
        <div class="offcanvas-header">
          <h5 class="offcanvas-title" id="offcanvasExampleLabel"><img class="pfimg1" src="../assets/car1.png" alt="" width="125" > <span class="hiden1"></span></h5>
          
          <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
        </div>
        
        <div class="form-inline serch1 hiden1">
            <div class="input-group" data-widget="sidebar-search">
                <input class="form-control form-control-sidebar" type="search" placeholder=" Search" aria-label="Search">
                <div class="input-group-append">
                   
                </div>
            </div>
        </div>


        <div class="offcanvas-body">
         
           
            <ul class="list-unstyled ps-0">
              <li class="mb-1 bodr1">
                <button class="btn btn-toggle d-inline-flex  rounded border-0 collapsed clr3" data-bs-toggle="collapse" data-bs-target="#dashbord-collapse" aria-expanded="false">
               <span class="pfimg1"><i class="fa fa-tachometer" aria-hidden="true"></i>  </span> 
              
               <span href="/" class="hiden1"> dashboard </span>
                </button>
                <div class="collapse mrgin1" id="dashbord-collapse">
                  
                </div>
              </li> 


                <li class="mb-1 bodr1">
                  <button class="btn btn-toggle d-inline-flex align-items-center rounded border-0 collapsed clr3" data-bs-toggle="collapse" data-bs-target="#dashboard-collapse" aria-expanded="false">
                  <span class="pfimg1"><i class="fa fa-car" aria-hidden="true"></i></span>
                    <span class="hiden1"> Issue Vehicle </span>
                  </button>
                  <div class="collapse mrgin1" id="dashboard-collapse">
                    <ul class="btn-toggle-nav list-unstyled fw-normal pb-1 ">
                      <li><a href="#" class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/miinventory/index">Manage Vehicle Inventory</router-link></a></li>
                      <li><a href="#" class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/mrentedvehicles/index">Manage Rented Vehicles</router-link></a></li>
                      <li><a href="#" class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/igrn/index">Return Vehicles</router-link></a></li>
                      
                    </ul>
                  </div>
                </li>
                <li class="mb-1 bodr1">
                  <button class="btn btn-toggle d-inline-flex align-items-center rounded border-0 collapsed clr3" data-bs-toggle="collapse" data-bs-target="#payment-collapse" aria-expanded="false">
                  <span class="pfimg1"><i class="fa fa-money" aria-hidden="true"></i> </span> 
                   <span class="hiden1"> Payments </span>
                  </button>
                  <div class="collapse mrgin1" id="payment-collapse">
                    <ul class="btn-toggle-nav list-unstyled fw-normal pb-1">
                      <li><a href="#" class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/sinvoice/index">Invoice</router-link></a></li>
                      <li><a href="#" class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/spaymentreceipts/indexoverpayment">Manage Security DeposSits</router-link></a></li>
                      <li><a href="#" class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/spaymentreceipts/index">Receipts</router-link></a></li>

                    </ul>
                  </div>
                </li>
                <li class="mb-1 bodr1">
                    <button class="btn btn-toggle d-inline-flex align-items-center rounded border-0 collapsed clr3" data-bs-toggle="collapse" data-bs-target="#report-collapse" aria-expanded="false">
                       <span class="pfimg1"><i class="fa fa-file-text" aria-hidden="true"></i> </span> 
                       <span class="hiden1"> Reports </span>
                    </button>
                    <div class="collapse mrgin1" id="report-collapse">
                      <ul class="btn-toggle-nav list-unstyled fw-normal pb-1  ">
                        <li><a href="#" class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/customer/index">Manage Customer</router-link></a></li>
                       
                      </ul>
                    </div>
                  </li>
                  <li class="mb-1 bodr1">
                    <button class="btn btn-toggle d-inline-flex align-items-center rounded border-0 collapsed clr3" data-bs-toggle="collapse" data-bs-target="#user-collapse" aria-expanded="false">
                       <span class="pfimg1"><i class="fa fa-user" aria-hidden="true"></i>


                       </span>
                        <span class="hiden1">   Users </span> 
                    </button>
                    <div class="collapse mrgin1" id="user-collapse">
                      <ul class="btn-toggle-nav list-unstyled fw-normal pb-1 ">
                        <li><a href="#" class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/user-management/user/index">Manage Users</router-link></a></li>
                        <li><a href="#" class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/user-management/role/index">Manage User Roles</router-link></a></li>
                        
                        
                      </ul>
                    </div>
                  </li>
         
                <li class="mb-1 bodr1">
                  <button class="btn btn-toggle d-inline-flex align-items-center rounded border-0 collapsed clr3" data-bs-toggle="collapse" data-bs-target="#account-collapse" aria-expanded="false">
                   <span class="pfimg1"><i class="fa fa-cog" aria-hidden="true"></i> </span> 
                   <span class="hiden1"> Settings </span>
                  </button>
                  <div class="collapse mrgin1" id="account-collapse">
                    <ul class="btn-toggle-nav list-unstyled fw-normal pb-1 ">
                      <li><a href="#" class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/mrate/index">Manage Rate Type</router-link></a></li>
                      <li><a href="#" class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/mcustomergroup/index">Manage Customer Group</router-link></a></li>
        
                      <li><a href="#" class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/mvehicles/index">Manage Vehicles Type</router-link></a></li>
                      <li><a href="#" class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/mbrand/index">Manage Brand</router-link></a></li>
                      <li><a href="#" class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/mmodels/index">Manage Models</router-link></a></li>
                      <li><a href="#" class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/audit/index">Audit Trail</router-link></a></li>
               
                     
                    </ul>
                  </div>
                </li>
              </ul>
            

        </div>
      </div>

</template>
<script>

</script>
<style>
.pfimg1{
    margin-right: 20px;
    border-radius: 13px;
}
.my {
        width: auto !important;
        padding-right: 25px ;
        height: auto;
        
 }
.bodr1{
    border-bottom: 2px #E4E5E6 solid;
    padding: 5px;
}
.bodr2{
    
    padding: 10px;
}
.mrgin1{
        margin-left: 35px;       
}

.serch1{
    margin-left: 5px;
    margin-top: 10px;
}
.serch2{
    margin-right: 5px;
}
.router2{
    text-decoration: none;
    color: black;
}
.router2:hover{
    color: white;
}
.clr3:hover{
    background-color: blue  !important;
    width: 100% !important;
    color: white;
}
.clr3:focus{
    background-color: blue !important;
    width: 100%;
    color: white  !important; 
}
@media only screen and (max-width: 768px) {
  .hiden1{
    display: none;
  }
}

</style>